import { ChevronRight, Trophy, FlagTriangleRight, MapPin, Users } from 'lucide-react'
import { getInitials } from '../utils/colors'

const matchTypeIcons = {
  quick_round: FlagTriangleRight,
  match: Trophy,
  trip: MapPin,
  team_match: Users,
}

export default function MatchCard({ match, onClick }) {
  const playerCount = match.match_players?.length || 0
  const Icon = matchTypeIcons[match.match_type] || Trophy

  // Find the owner's player record from match_players
  const ownerMatchPlayer = match.match_players?.find(mp => mp.user_id != null && mp.user_id === match.owner_id)
  const ownerPlayer = ownerMatchPlayer?.player
  const ownerName = ownerPlayer?.display_name || [ownerPlayer?.first_name, ownerPlayer?.last_name].filter(Boolean).join(' ') || 'Unknown'
  const ownerInitials = ownerPlayer ? getInitials(ownerPlayer) : ownerName.charAt(0).toUpperCase()
  const ownerColor = ownerPlayer?.avatar_color || '#34d399'

  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '1rem',
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: '0.75rem',
        border: '1px solid var(--border-color)',
        textAlign: 'left',
        width: '100%',
        minHeight: '64px',
      }}
    >
      <div style={{
        width: '56px',
        height: '56px',
        borderRadius: '0.5rem',
        backgroundColor: 'rgba(var(--accent-primary-rgb, 14, 164, 122), 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icon size={28} style={{ color: 'var(--accent-primary)' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: '600', fontSize: '0.9375rem', marginBottom: '0.125rem' }}>
          {match.match_name}
        </div>
        <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginBottom: '0.25rem' }}>
          {playerCount} player{playerCount !== 1 ? 's' : ''} &middot; {new Date(match.created_at).toLocaleDateString()}
        </div>
        {/* Owner row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          <div style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            backgroundColor: ownerColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontSize: '0.5rem',
            fontWeight: '700',
            color: '#fff',
          }}>
            {ownerInitials}
          </div>
          <span style={{ fontSize: '0.6875rem', color: 'var(--text-muted)' }}>
            {ownerName}
          </span>
        </div>
      </div>
      <ChevronRight size={20} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
    </button>
  )
}
